
// src/web/components/chat-album-video-item.jsx

import React from 'react'
import classnames from 'classnames'
import _ from 'lodash'
import moment from 'moment'
import { IconButton } from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import Avatar from 'react-toolbox/lib/avatar'

class AlbumVideoItem extends React.Component {
  showImagesView = (video) => this.props.showImagesView('OUT_OF_LIST', undefined, video)
  render() {
    const {
      video,
      users,
      postName,
      showImagesView,
    } =this.props

    const num = video && video.name.lastIndexOf('.')
    const basename = num != -1 && video.name.slice(0, num) || video.name
    const extension = num != -1 && video.name.slice(num + 1, video.name.length).toLowerCase() || ''
    // ファイル名が長い場合は途中を...で省略する
    const videoname = (basename.length > 20 ? basename.slice(0, 20) + '...' + extension : video.name)

    //動画の再生時間
    const minutes = video.duration && Math.floor(video.duration / 60) || '0'
    const seconds = video.duration && (video.duration % 60) || '0'
    const duration = minutes + ":" + (seconds < 10 ? '0' : '') + seconds

    return (
      video.content_type.match(/^video/) && video.status == 'committed' &&
      <div style={{padding: '2.5%', cursor: 'pointer'}} onClick={()=> this.showImagesView(video)}>
        <div style={{position: 'relative', height: '75%',}}>
          <img 
            style={{ height: '100%',width: '100%', borderTopLeftRadius: 10, borderTopRightRadius: 10}}
            src={video.file.thumb_url} />
            <div style={{display: 'flex', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, justifyContent: 'center', alignItems: 'center'}}>
              <Avatar icon="play_arrow" />
            </div>
            {video.duration ?
              <div style={{ position: 'absolute', borderRadius: 5, margin: 5, padding: 3, right: 0, bottom: 0, backgroundColor: '#000', justifyContent: 'center', alignItems: 'center'}} >
                <p style={{ color: '#FFFFFF' }}>{duration}</p>
            </div> : null}
        </div>
        <div style={{backgroundColor: '#dadce0', height: '25%', padding: '5px 16px 5px 16px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>
          <p style={{ color: 'rgb(33, 33, 33)' }}>{videoname}</p>
          <p style={{ color: 'rgb(117, 117, 117)' }}>{video.user.name}</p>
          <p style={{ color: 'rgb(117, 117, 117)' }}>{moment(video.created_at).format(`LLL`)}</p>
        </div>
      </div>||
      <div style={{padding: '2.5%', cursor: 'pointer'}} onClick={()=> this.showImagesView(video)}>
        <div style={{position: 'relative', justifyContent: 'center',alignItems: 'center', height: '75%', backgroundColor: 'whitesmoke', borderTopLeftRadius: 10, borderTopRightRadius: 10}}>
          <FontIcon value='music_note' style={{fontSize: 50, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', WebkitTransform: 'translate(-50%, -50%)', msTransform: 'translate(-50%, -50%)'}}/>
          {video.duration ?
            <div style={{ position: 'absolute', borderRadius: 5, margin: 5, padding: 3, right: 0, bottom: 0, backgroundColor: '#000', justifyContent: 'center', alignItems: 'center'}} >
              <p style={{ color: '#FFFFFF' }}>{duration}</p>
            </div> : null}
        </div>
        <div style={{backgroundColor: '#dadce0', height: '25%', padding: '5px 16px 5px 16px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>
          <p style={{ color: 'rgb(33, 33, 33)' }}>{videoname}</p>
          <p style={{ color: 'rgb(117, 117, 117)' }}>{video.user.name}</p>
          <p style={{ color: 'rgb(117, 117, 117)' }}>{moment(video.created_at).format(`LLL`)}</p>
        </div>
      </div>
    )
  }
}

export default AlbumVideoItem


// WEBPACK FOOTER //
// ./src/web/components/album-video-item.jsx